import React from "react";
import { Box } from "@mui/material";
import {
  MyHrSettingsChangeRequestsCard,
  MyHrSettingsPayrollCard,
  MyHrSettingsTaxCreditApplicationCard,
} from "my-hr/components";
import { OcPageSideMenu, OcPageTransition } from "oc/components";
import {
  useOcCustomerLicences,
  useOcIsMobile,
  useOcPageSideMenu,
} from "oc/hooks";

const menuDef = [
  {
    id: "changeRequestSettings",
    label: "OC_GENERAL_SETTINGS",
    roles: ["MyHR.admin"],
  },
];

export const MyHRAdminSettingsPage = () => {
  const stateId = "myHrSettingsPageMenuActiveItem";
  const { state: selectedItem } = useOcPageSideMenu({
    id: stateId,
    initialValue: menuDef[0].id,
  });

  const isMobile = useOcIsMobile();

  const { licences } = useOcCustomerLicences();
  const changeRequestsEnabled = licences?.myHRChangeData || false;
  const saveTaxApplicationsEnabled = licences?.myHRSaveTaxApplications || false;

  return (
    <OcPageTransition>
      <Box>
        <Box
          id="my-hr-admin-settings-title"
          height="80px"
          style={{ backgroundColor: "#cc0033" }}
          display="flex"
          flexDirection="row"
          alignItems="center"
          paddingLeft="14px"
        >
          <Box style={{ color: "white", fontSize: "24px" }}>MyHR</Box>
        </Box>
        <Box display="flex" flexDirection={isMobile ? "column" : "row"}>
          <OcPageSideMenu stateId={stateId} menuDef={menuDef} />

          <Box
            id="my-hr-admin-system-settings"
            flexGrow={1}
            padding={isMobile ? "16px 0px" : "16px"}
          >
            {selectedItem === "changeRequestSettings" && (
              <>
                <MyHrSettingsChangeRequestsCard
                  changeRequestsEnabled={changeRequestsEnabled}
                  isMobile={isMobile}
                />
                <Box height="16px" />
                <MyHrSettingsPayrollCard
                  isMobile={isMobile}
                />
                <Box height="16px" />
                <MyHrSettingsTaxCreditApplicationCard
                  saveTaxApplicationsEnabled={saveTaxApplicationsEnabled}
                  isMobile={isMobile}
                />
              </>
            )}
          </Box>
        </Box>
      </Box>
    </OcPageTransition>
  );
};

export default MyHRAdminSettingsPage;
